import React from 'react';
import moment from 'moment';
import {makeStyles} from "@material-ui/styles";
import BootstrapLoadingButton from "../../Ui/BootstrapLoadingButton";
import Pagination from "@material-ui/lab/Pagination";
import CircularProgress from "@material-ui/core/CircularProgress";
import {Link, useHistory} from "react-router-dom";
import {convertToLocalState} from "../../../utils/helpers";
import FicheStateButton from "./FicheStateButton";
import {societes} from "../../../utils/constants";
import axios from "axios";
import {GET_FETCH_CODE} from "../../../api/Api";
import {toast} from "react-toastify";

const useStyles = makeStyles(
    (theme) => {
        return {
            tableBody: {
                '& > tr:nth-child(odd)': {
                    // backgroundColor: '#E5EAEE',
                    backgroundColor: '#E5EAEE',
                },
                '& > tr:nth-child(even)': {
                    backgroundColor: '#fff',
                }
            },

            overlay: {
                position: 'absolute',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255,255,255,0.5)',
                zIndex:3
            },
            containerBg: {
                backgroundColor: '#fbe6d5'
            },
            abonnementItem: {
                '&:hover': {
                    // backgroundColor: `${theme.palette.primary.dark}!important`,
                    backgroundColor: `#f9f1ea!important`,
                    cursor: 'pointer'
                }
            }
        }
    }
)

export default function FicheList(props){

    const classes = useStyles();

    const history = useHistory();

    const {searchResultPagined,searchResultPageState,isLoadingPage,onGoToPage,onFicheUpdated} = props;

    const [enregistrementUnderEdition,setEnregistrementUnderEdition] = React.useState();

    const [isCreatingEnregistrement,setIsCreatingEnregistrement] = React.useState(false);

    const [searchingCodeItemId,setSearchingCodeItemId] = React.useState(-1);
    const cancelToken = React.useRef(undefined);


    const currentItems = React.useMemo(
        () => {
            return searchResultPagined[searchResultPageState.currentPage] || [];
        },[searchResultPageState.currentPage,searchResultPagined]
    );

    async function loadItemDetailsCodeAndGo(item,index){

        try{

            if(cancelToken.current)
                cancelToken.current('Opération annulé');

            cancelToken.current = undefined;


            setSearchingCodeItemId(item.id);

            const response = await axios.get(
                `${GET_FETCH_CODE}`,
                {
                    params: {
                        email: item.email,
                        code: item.code
                    },
                    cancelToken: new axios.CancelToken((c) =>{

                        cancelToken.current = c;

                    })

                }
            );

            history.push(`/fiches/details/${response.data}`)

        } catch (e) {

            if(e.response && e.response.status === 404)

            toast.error('Aucune demande correspondante trouver', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        } finally {
            setSearchingCodeItemId(-1);
        }

    }


    function onPageChange(event,page){
        console.log('on page change=>',page)
        if(onGoToPage)
            onGoToPage(page);
    }

    function onFicheItemUpdated(fiche){

        if(onFicheUpdated)
            onFicheUpdated(fiche)

    }

    return (
        <div className={``}>

            <div className="">
                <div className="">

                    {/*{*/}
                    {/*    searchResultPagined && searchResultPageState.count > 0 && (*/}
                    {/*        <div className={'text-muted font-weight-lighter mr-5'}>*/}
                    {/*            <span className={'font-weight-bold text-primary'}>{searchResultPageState.count}</span> resultats trouvées*/}
                    {/*        </div>*/}
                    {/*    )*/}
                    {/*}*/}

                </div>
            </div>

            {
                searchResultPagined && searchResultPageState.count > 0 && (
                    <div className=" position-relative overflow-hidden">

                        <table className="table table-borderless table-vertical-center">
                            <thead>
                            <tr className={'bg-primary text-white text-center'}>
                                <th className="py-4" >Société</th>
                                <th className="p-0" >Objet de la demande</th>
                                <th className="p-0" >Nom</th>
                                <th className="p-0" >Prénom</th>
                                <th className="p-0" >Raison Sociale</th>
                                <th className="p-0" >Numéros de téléphone</th>
                                <th className="p-0" >Ville</th>
                                <th className="p-0" >Commune</th>
                                <th className="p-0" >Statut</th>
                                <th className="p-0" >Date de transmission</th>
                                <th className="p-0" >Date de dernière mise à jour</th>
                                <th className="p-0" >Date de début des travaux</th>
                                <th className="p-0" >Numéro de demande PGT</th>
                                <th className="p-0" >Actions</th>
                            </tr>
                            </thead>
                            <tbody className={`${classes.tableBody} text-center`}>

                            {
                                currentItems.map(
                                    (item,index) => {

                                        const state = convertToLocalState(item.state);

                                        return (
                                            <tr className={` ${classes.abonnementItem}`} key={item.id}>
                                                <td className="pl-0">
                                                    <span className="text-dark font-weight-500">{societes[item.type_travaux]}</span>
                                                </td>
                                                <td className="pl-0">
                                                    <span className="text-dark">{
                                                        [...item.nature_travaux_data.map(nature => nature.libelle), item.autre_cie, item.autre_sodecie]
                                                            .filter(nature=>!!nature).map(
                                                            (nature, index) => {
                                                                if (index === item.nature_travaux_data.length)
                                                                    return nature;

                                                                return nature + ', ';
                                                            }
                                                        )
                                                    }</span>
                                                </td>
                                                <td className="pl-0">
                                                    <span className="text-dark">{item.nom}</span>
                                                </td>
                                                <td className="pl-0">
                                                    <span className="text-dark">{item.prenoms}</span>
                                                </td>
                                                <td className="pl-0">
                                                    <span className="text-dark">{item.raison_sociale}</span>
                                                </td>
                                                <td className="pl-0">
                                                    <span className="text-dark">{item.mobile}</span>
                                                </td>
                                                <td className="pl-0">
                                                    <span className="text-dark font-weight-bolder">
                                                            {item.villes?.map(
                                                                (ville,index) => {

                                                                    if(index == item.villes.length - 1)
                                                                        return ville.libelle;

                                                                    return ville.libelle + ', '
                                                                }
                                                            )}</span>
                                                </td>
                                                <td className="pl-0">
                                                    <span className="text-dark font-weight-bolder">

                                                            {item.communes.map(
                                                                (commune,index) => {

                                                                    if(index == item.communes.length - 1)
                                                                        return commune.libelle;

                                                                    return commune.libelle + ', '
                                                                }
                                                            )}

                                                    </span>
                                                </td>
                                                <td className="pl-0">

                                                    {
                                                        state === -1 && (
                                                            <span className={'btn btn-light-danger font-weight-bold'}>
                                                                Annulé
                                                            </span>
                                                        )
                                                    }

                                                    {
                                                        state === 2 && (
                                                            <span className={'btn btn-light-primary font-weight-bold'}>
                                                                En cours d'analyse
                                                            </span>
                                                        )
                                                    }

                                                    {
                                                        state === 3 && (
                                                            <span className={'btn btn-light-info'}>
                                                                En cours de prise en compte
                                                            </span>
                                                        )
                                                    }

                                                    {
                                                        state === 4 && (
                                                            <span className={'btn btn-success'}>
                                                                Terminer
                                                            </span>
                                                        )
                                                    }

                                                </td>
                                                <td className="pl-0">
                                                    <span className="text-dark">{item.transmition_date ? moment(item.transmition_date).format('DD/MM/YYYY') : '-'}</span>
                                                </td>
                                                <td className="pl-0">
                                                    <span className="text-dark">{moment(item.updated_at).format('DD/MM/YYYY')}</span>
                                                </td>
                                                <td className="pl-0">
                                                    <span className="text-dark">{moment(item.date_debut_travaux).format('DD/MM/YYYY')}</span>
                                                </td>
                                                <td className="pl-0">
                                                    <span className="text-dark">{item.code}</span>
                                                </td>
                                                <td className="pl-0">

                                                    {/*<FicheStateButton onFicheUpdated={onFicheItemUpdated} fiche={item} />*/}

                                                    <BootstrapLoadingButton isLoading={item.id === searchingCodeItemId} onClick={()=>{
                                                        loadItemDetailsCodeAndGo(item,index)
                                                    }} className={'btn btn-small btn-light-primary'}>
                                                            VOIR
                                                    </BootstrapLoadingButton>

                                                </td>
                                            </tr>
                                        )
                                    }
                                )
                            }

                            </tbody>
                        </table>

                        <div className={'position-relative'}>

                            <Pagination color={'primary'} count={searchResultPageState.totalPages} page={searchResultPageState.currentPage} onChange={onPageChange} />

                            {
                                isLoadingPage && (
                                    <div className={classes.overlay}>
                                        <CircularProgress size={16} disableShrink />
                                    </div>
                                )
                            }

                        </div>

                    </div>
                )
            }


            {
                searchResultPageState &&
                searchResultPageState.count == 0 && (
                    <div className={'px-5 py-5 text-center h3 font-weight-lighter'}>
                        Aucune fiche n'a trouvée
                    </div>
                )
            }



        </div>
    );
}